import { createSlice } from '@reduxjs/toolkit'
import {
  getGeneralStatistics,
  getConsultationsByPeriod,
  getConsultationsNext,
  getBirthdayPeopleOfDay,
  getConsultationsNextPatient,
  getHealthRecordDocumentsPatient,
} from '../services/dashboardService'

const initialState = {
  generalStatistics: {
    data: {
      countPatients: 0,
      countPatientsBySexPercent: {
        M: 0,
        F: 0,
      },
      countConsultations: 0,
    },
    loading: false,
    error: null,
    receivedAt: null,
  },
  consultationsByPeriod: {
    data: [],
    loading: false,
    error: null,
    receivedAt: null,
    selectedPeriod: '12months',
    selectedSpecialtyId: null,
  },
  consultationsNext: {
    data: [],
    loading: false,
    error: null,
    receivedAt: null,
  },
  consultationsNextPatient: {
    data: [],
    loading: false,
    error: null,
    receivedAt: null,
  },
  birthdayPeopleOfDay: {
    data: [],
    loading: false,
    error: null,
    receivedAt: null,
    selectedBirthdayType: 'all',
  },
  healthRecordDocumentsPatient: {
    data: [],
    loading: false,
    error: null,
    receivedAt: null,
  },
}

const dashboardSlice = createSlice({
  name: 'dashboard',
  initialState,
  reducers: {
    requestGeneralStatisticsStart(state) {
      state.generalStatistics.loading = true
      state.generalStatistics.error = null
    },
    requestGeneralStatisticsSuccess(state, action) {
      state.generalStatistics.loading = false
      state.generalStatistics.data = action.payload
      state.generalStatistics.receivedAt = Date.now()
    },
    requestGeneralStatisticsFailure(state, action) {
      state.generalStatistics.loading = false
      state.generalStatistics.error = action.payload
      state.generalStatistics.receivedAt = null
    },
    requestConsultationsByPeriodStart(state) {
      state.consultationsByPeriod.loading = true
      state.consultationsByPeriod.error = null
    },
    requestConsultationsByPeriodSuccess(state, action) {
      state.consultationsByPeriod.loading = false
      state.consultationsByPeriod.data = action.payload.data
      state.consultationsByPeriod.selectedPeriod = action.payload.period
      state.consultationsByPeriod.selectedSpecialtyId = action.payload.specialtyId
      state.consultationsByPeriod.receivedAt = Date.now()
    },
    requestConsultationsByPeriodFailure(state, action) {
      state.consultationsByPeriod.loading = false
      state.consultationsByPeriod.error = action.payload
      state.consultationsByPeriod.receivedAt = null
    },
    updateSelectedBirthdayType(state, action) {
      state.birthdayPeopleOfDay.selectedBirthdayType = action.payload
    },
    requestConsultationsNextPatientStart(state) {
      state.consultationsNextPatient.loading = true
      state.consultationsNextPatient.error = null
    },
    requestConsultationsNextPatientSuccess(state, action) {
      state.consultationsNextPatient.loading = false
      state.consultationsNextPatient.data = action.payload
      state.consultationsNextPatient.receivedAt = Date.now()
    },
    requestConsultationsNextPatientFailure(state, action) {
      state.consultationsNextPatient.loading = false
      state.consultationsNextPatient.error = action.payload
      state.consultationsNextPatient.receivedAt = null
    },
    requestConsultationsNextStart(state) {
      state.consultationsNext.loading = true
      state.consultationsNext.error = null
    },
    requestConsultationsNextSuccess(state, action) {
      state.consultationsNext.loading = false
      state.consultationsNext.data = action.payload
      state.consultationsNext.receivedAt = Date.now()
    },
    requestConsultationsNextFailure(state, action) {
      state.consultationsNext.loading = false
      state.consultationsNext.error = action.payload
      state.consultationsNext.receivedAt = null
    },
    requestBirthdayPeopleOfDayStart(state) {
      state.birthdayPeopleOfDay.loading = true
      state.birthdayPeopleOfDay.error = null
    },
    requestBirthdayPeopleOfDaySuccess(state, action) {
      state.birthdayPeopleOfDay.loading = false
      state.birthdayPeopleOfDay.data = action.payload
      state.birthdayPeopleOfDay.receivedAt = Date.now()
    },
    requestBirthdayPeopleOfDayFailure(state, action) {
      state.birthdayPeopleOfDay.loading = false
      state.birthdayPeopleOfDay.error = action.payload
      state.birthdayPeopleOfDay.receivedAt = null
    },
    requestHealthRecordDocumentsPatientStart(state) {
      state.healthRecordDocumentsPatient.loading = true
      state.healthRecordDocumentsPatient.error = null
    },
    requestHealthRecordDocumentsPatientSuccess(state, action) {
      state.healthRecordDocumentsPatient.loading = false
      state.healthRecordDocumentsPatient.data = action.payload
      state.healthRecordDocumentsPatient.receivedAt = Date.now()
    },
    requestHealthRecordDocumentsPatientFailure(state, action) {
      state.healthRecordDocumentsPatient.loading = false
      state.healthRecordDocumentsPatient.error = action.payload
      state.healthRecordDocumentsPatient.receivedAt = null
    },
    resetDashboard(state) {
      return initialState
    },
  },
})

export const {
  requestGeneralStatisticsStart,
  requestGeneralStatisticsSuccess,
  requestGeneralStatisticsFailure,
  requestConsultationsByPeriodStart,
  requestConsultationsByPeriodSuccess,
  requestConsultationsByPeriodFailure,
  updateSelectedBirthdayType,
  requestConsultationsNextPatientStart,
  requestConsultationsNextPatientSuccess,
  requestConsultationsNextPatientFailure,
  requestConsultationsNextStart,
  requestConsultationsNextSuccess,
  requestConsultationsNextFailure,
  requestBirthdayPeopleOfDayStart,
  requestBirthdayPeopleOfDaySuccess,
  requestBirthdayPeopleOfDayFailure,
  requestHealthRecordDocumentsPatientStart,
  requestHealthRecordDocumentsPatientSuccess,
  requestHealthRecordDocumentsPatientFailure,
  resetDashboard,
} = dashboardSlice.actions
export default dashboardSlice.reducer

/**
 * Fabrica estatísticas gerais.
 */
export const fetchGeneralStatistics = () => async (dispatch, getState) => {
  try {
    // const state = getState()

    // carrega apenas uma vez
    // if (state.dashboard.generalStatistics.loading) return
    // if (state.dashboard.generalStatistics.data) return

    dispatch(requestGeneralStatisticsStart())

    const response = await getGeneralStatistics()

    dispatch(requestGeneralStatisticsSuccess(response))

  } catch (error) {
    dispatch(requestGeneralStatisticsFailure(error.message))
  }
}

/**
 * Fabrica consultas por período.
 */
export const fetchConsultationsByPeriod = (period = null, specialtyId = null) => async (dispatch, getState) => {
  try {
    const state = getState()
    const selectedPeriod = period || state.dashboard.consultationsByPeriod.selectedPeriod
    const selectedSpecialtyId = specialtyId !== undefined ? specialtyId : state.dashboard.consultationsByPeriod.selectedSpecialtyId

    dispatch(requestConsultationsByPeriodStart())
    const response = await getConsultationsByPeriod(selectedPeriod, selectedSpecialtyId)

    // Passa os parâmetros usados na requisição para atualizar o estado
    dispatch(requestConsultationsByPeriodSuccess({
      data: response.data,
      period: response.period,
      specialtyId: response.specialtyId
    }))
  } catch (error) {
    dispatch(requestConsultationsByPeriodFailure(error.message))
  }
}

/**
 * Fabrica consultas próximas.
 */
export const fetchConsultationsNext = (limit = 100) => async (dispatch, getState) => {
  try {
    dispatch(requestConsultationsNextStart())
    const response = await getConsultationsNext(limit)
    dispatch(requestConsultationsNextSuccess(response))
  } catch (error) {
    dispatch(requestConsultationsNextFailure(error.message))
  }
}

/**
 * Fabrica consultas próximas do paciente logado.
 */

export const fetchConsultationsNextPatient = (limit = 100) => async (dispatch, getState) => {
  try {
    dispatch(requestConsultationsNextPatientStart())
    const response = await getConsultationsNextPatient(limit)
    dispatch(requestConsultationsNextPatientSuccess(response))
  } catch (error) {
    dispatch(requestConsultationsNextPatientFailure(error.message))
  }
}

/**
 * Fabrica aniversariantes do dia.
 */
export const fetchBirthdayPeopleOfDay = (type = null) => async (dispatch, getState) => {
  try {
    const state = getState()
    const selectedBirthdayType = type || state.dashboard.birthdayPeopleOfDay.selectedBirthdayType

    // Atualiza o tipo no estado se um novo tipo foi fornecido
    if (type && type !== state.dashboard.birthdayPeopleOfDay.selectedBirthdayType) {
      dispatch({ type: 'dashboard/updateSelectedBirthdayType', payload: type })
    }

    dispatch(requestBirthdayPeopleOfDayStart())
    const response = await getBirthdayPeopleOfDay(selectedBirthdayType)
    dispatch(requestBirthdayPeopleOfDaySuccess(response))
  } catch (error) {
    dispatch(requestBirthdayPeopleOfDayFailure(error.message))
  }
}

/**
 * Fabrica documentos de prontuário do paciente logado.
 */
export const fetchHealthRecordDocumentsPatient = (limit = 100) => async (dispatch, getState) => {
  try {
    dispatch(requestHealthRecordDocumentsPatientStart())
    const response = await getHealthRecordDocumentsPatient(limit)
    dispatch(requestHealthRecordDocumentsPatientSuccess(response))
  } catch (error) {
    dispatch(requestHealthRecordDocumentsPatientFailure(error.message))
  }
}